@if (product) {
<div class="product-list-item-doc">
  <div class="row ">
    <div class="col-12 col-md-4">
      <div class="dtc-code" [innerHtml]="product.type  | searchHighlight:searchQuery "></div>
      <div class="dtc-type" [innerHtml]="product.typeName  | searchHighlight:searchQuery "></div>
    </div>
    <div class="col-12 col-md-4">
      @if (product.internalCode1) {
      <div class="internalCode1">{{'DTC_PAGE.internalCode1'|cxTranslate}} <span
          [innerHtml]="product.internalCode1  | searchHighlight:searchQuery "></span></div>
      }
      @if (product.internalCode2) {
      <div class="internalCode2">{{'DTC_PAGE.internalCode2'|cxTranslate}} <span
          [innerHtml]="product.internalCode2  | searchHighlight:searchQuery "></span></div>
      }
      @if (product?.hexCode) {
      <div class="internalCode2">{{'DTC_PAGE.hexCode'|cxTranslate}} <span [innerHtml]="product.hexCode  | searchHighlight:searchQuery "></span>
      </div>
      }
      @if (product?.spnfmi) {
      <div class="internalCode2">{{'DTC_PAGE.FMI'|cxTranslate}} <span [innerHtml]="product.spnfmi  | searchHighlight:searchQuery "></span>
      </div>
      }
    </div>
    <div class="col-12 col-md-4">
      @if (product.sheetUrl) {
      <div class="download-btn-outer">
        <a href="{{product.sheetUrl}}" target="_blank" class="btn button" rel="noopener">
          {{'DTC_PAGE.downloadDocument'|cxTranslate}}
          <img src="/icons/link-grey.svg" class="icon-right" alt="">
        </a>
      </div>
      }
      <div class="download-btn-outer">
        <!--  <a [routerLink]="['/troubleShootingSteps']" (click)="onTroubleshootClick(product)" target="_self"
          class="btn button-launch" rel="noopener">
          Troubleshooting Steps
        </a> -->
        <button type="button" class="btn button-launch" (click)="onTroubleshootClick(product)">
          {{'DTC_PAGE.troubleshootingSteps'|cxTranslate}}
        </button>
      </div>
    </div>
  </div>
  <div class="product-type" [innerHtml]="product.productType  | searchHighlight:searchQuery "></div>
  <div class="dtc-desc" [innerHtml]="product.description  | searchHighlight:searchQuery "></div>
</div>
}